/* #region z-indexes */

export const CONTEXT_MENU_ZINDEX = 5;
export const FULLY_BLOCKING_POPUP_ZINDEX = 4;
export const FLOATING_CONTAINER_ZINDEX = 3;
export const PARTIALLY_BLOCKING_POPUP_ZINDEX = 2;
export const BLOCKING_LAYER_ZINDEX = 1;

/* #endregion z-indexes */

/* #region Time constants */

export const ONE_SECOND_INTERVAL_MS = 1000;
export const FIVE_SECONDS_INTERVAL_MS = 5000;
export const MS_BEFORE_SKIPPING_TO_PREVIOUS = 5000;
export const TOO_MANY_REQUESTS_BLOCKING_WAITING_TIME_S = 5;

/* #endregion Time constants */

/* #region Clearing queue constants */

export const CLEAR_QUEUE_TRACK_COUNT_SAFETY_STOP = 25;
export const CLEAR_QUEUE_DEFAULT_TIMEOUT_DELAY = 250;
export const CLEAR_QUEUE_STOP_TIMEOUT_DELAY = 3000;
export const CLEAR_QUEUE_FLAG_TRACK_ID = '0o12mLSQuXFgsh4e2Kc4e5';
export const CLEAR_QUEUE_FLAG_TRACK_URI = `spotify:track:${CLEAR_QUEUE_FLAG_TRACK_ID}`;
export const CLEAR_QUEUE_FLAG_TRACK_COUNT = 3;

/* #endregion Clearing queue constants */
